export default function cloneData(data) {
    return data.map((item) => (Object.assign({}, item)));
}
//# sourceMappingURL=cloneData.js.map